<template>
  <div>
    <iframe
      width="100%"
      height="500"
      :src="youtubeLiveEmbedUrl()"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</template>
<script>
import { getYoutubeLiveEmbedUrl } from "@/helpers";
import i18n from "@/i18n";
export default {
    name: "YoutubeLive",
    props: {
        meta: {
            type: Object,
            default: null
        }
    },
    mounted() {
      this.showNotification()
    },
    methods: {
      youtubeLiveEmbedUrl(autoplay=true){
        return getYoutubeLiveEmbedUrl(this.meta.content, autoplay);
      },
      /** Show notification: Event is about to start */
      showNotification() {
        this.$store.dispatch("app/showSupportNotification", {
          screener_id: this.meta.screener_id,
          message: this.meta.title + i18n.t("screener.meeting.is_about_to_stream")
        });
      }
    }
};
</script>
